<dynamic-form
  [apiName]="apiName"
  [group]="formGroup"
  [noChangeLabel]="true"
  [areaName]="areaName"
  [model]="model"
  [label]="label"
  savingLabel="درحال صدور سند"
  saveLabel="صدور سند"
  (cancelChange)="cancel()"
  (submitChange)="save()">
  <ng-container class="content">
    <date-picker
      id="dpVoucherDate"
      [defaultHeight]="30"
      [group]="formGroup"
      name="VoucherDate"
      label="تاریخ"
      [required]="true"
      textType="text"
      [disabled]="false">
    </date-picker>
  </ng-container>
  <ng-container class="footer">
    <ssg-button
      icon="fa fa-filter"
      buttontype="button"
      (click)="deletVoucher()"
      class="login-btn"
      label="حذف سند"
      size="medium"
      [disabled]="!model?.Id"
      appearance="flat">
    </ssg-button>
  </ng-container>
</dynamic-form>
